import { z } from 'zod';
import { TextItem } from './common';
export var DistractingActivity = TextItem;
export var DistractingActivities = z.array(DistractingActivity).prefault([]);
